import { t } from '../translations';

export const isStudioPage = () => {
  const path = window.location.pathname;
  if (path.includes(t('studio'))) return true;
  if (path.includes('ubikstudio')) return true;
  return false;
};

export const isProjectsPage = () => {
  const path = window.location.pathname;
  if (path.includes(t('my-account-projects'))) return true;
  return false;
};

export const isHelpCenterHomepage = () => {
  const path = window.location.pathname;
  const url = window.location.href;
  if (path === t('helpCenterHomepage')) return true;
  if (url.includes('help-center-page.care-staging.vpsvc.com')) return true;
  return false;
};

export const isHelpCenterPage = () => {
  const path = window.location.pathname;
  const url = window.location.href;
  if (path.includes(t('helpCenter'))) return true;
  if (url.includes('help-center-page.care-staging.vpsvc.com')) return true;
  return false;
};

export const isPPAGLearnPage = () => {
  const pageURL = window.location.href;
  if (pageURL.includes('discover-and-learn')) return true;
  return false;
};

export const isDiscoveryPage = () => {
  const isClothingBagsPage = window.location.href.includes(t('clothingBags'));
  const isPromotionalProductPage = window.location.href.includes(t('promotionalProduct'));
  return isClothingBagsPage || isPromotionalProductPage;
};

export const isOrderHelpPage = () => window.location.href.includes(t('order-help-v2'));
